import { Component, ViewChild, Input, Output, EventEmitter, OnInit, OnChanges, SimpleChange, ChangeDetectorRef, Directive, Inject } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from '../../services/language.service';

import { DialogInnovacio } from '../../dialog/innovacio/dialog.component.innovacio';
import { DialogAvaluar } from '../../dialog/avaluar/dialog.component.avaluar';
import { DialogFitxes } from '../../dialog/fitxes/dialog.component.fitxes';

import { MatDialog, MatDialogRef, MatDialogConfig } from '@angular/material/dialog';
import { MAT_DIALOG_DATA } from "@angular/material/dialog";

import { FormatNumberPipe } from '../../pipes/formatnumber';
import { NumberFormatPipe } from '../../pipes/number.pipe';

import { TokenStorageService } from '../../services/auth-user-service/token-storage.service';
import { ProjectsService, ProposalsService } from '../../services/projects-proposals-service/projects-proposals.service';
import { NotesService } from '../../notes/notes.service';
import { CurrencyDialogComponent } from '../../dialog/currencies/currency-dialog.component';

import { RequestChange } from '../interfaces';
import { IFLInnovacio, IFLSotware } from '../../dialog/innovacio/innovacio.interfaces';
import { IFRFitxa } from '../../dialog/fitxes/fitxes.interfaces';

import { fromEvent, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import * as moment from 'moment';

@Directive()
export class BaseDataComponent implements OnInit, OnChanges {
  @Input() data: any;
  @Input() isNew: boolean;
  @Input() showAsyncProgress: boolean = false;
  @Output() requestChange: EventEmitter<RequestChange> = new EventEmitter<RequestChange>();

  //public possibleStates: Array<string>;
  public possibleStates: { codi: string; text: string; }[];

  public tematica1: Array<string>;
  public tematica2: Array<string>;
  public tematica3: Array<string>;
  public tematica4: Array<string>;
  public tematica5: Array<string>;
  //public possibleAmbits: Array<string>;
  public possibleAmbits: { codi: string; text: string; }[];

  //public possibleMonedes: Array<string>;
  public possibleMonedes: { codi: string; text: string; }[];

  //public possibleTipus: Array<string>;
  public possibleTipus: { codi: string; text: string; }[];

  public possibleMotius: Array<any>;
  public possibleCPV: Array<any>;
  public cpv: Array<any>;
  //public possibleTematiques1: Array<any>;
  public possibleTematiques1: { codi: string; text: string; }[];
  //public possibleTematiques2: Array<any>;
  public possibleTematiques2: { codi: string; text: string; }[];
  //public possibleTematiques3: Array<any>;
  public possibleTematiques3: { codi: string; text: string; }[];
  //public possibleTematiques4: Array<any>;
  public possibleTematiques4: { codi: string; text: string; }[];
  //public possibleTematiques5: Array<any>;
  public possibleTematiques5: { codi: string; text: string; }[];

  //public possibleConsorcis: Array<any>;
  public possibleConsorcis: { codi: string; text: string; }[];

  //public possibleUtes: Array<any>;
  public possibleUtes: { codi: string; text: string; }[];

  //public possibleTipGarantia: Array<any>;
  public possibleTipGarantia: { codi: string; text: string; }[];

  //public seguimentsTreballs: any;
  public seguimentsTreballs: { codi: string; text: string; }[];

  public possibleIncidencia: { codi: string; text: string; }[];
  public possiblePropIncidencies: { codi: string; text: string; }[];
  public possiblePropEnIncidencies: { codi: string; text: string; }[];
  public possiblePropConIncidencies: { codi: string; text: string; }[];
  public possiblePrePropIncidencies: { codi: string; text: string; }[];

  public incidenciesActuals: any[] = [];
  public desable: boolean = true;
  public espotDesar: boolean = true;
  public percentatge_subcon: number = 0;
  public percentatge_propi: number = 0;
  private file;
  public showDialog: boolean = false;
  public innovacioData: IFLInnovacio;
  public editInnovacioData: IFLInnovacio;
  public editSoftData: IFLSotware;
  private tipus_proposta_inicial: number = null;
  public proposta: boolean = true;
  public rol: any = 0;
  public dia: string = null;
  public diaFull: string = null;  
  public descripcio: string = '';
  public userInfo: any = {};
  private unsubscriber : Subject<void> = new Subject<void>();
  public quillPos: number = 0;
  public fitxaComanda: Array<any>;
  public imgname: Array<string>;

  public openCurrencyDialog(): void {
    this.dialog.open(CurrencyDialogComponent, {
      panelClass: 'currency-dialog-panel',
      autoFocus: false
    });
  }

  public onEstatChange() {
    if (this.data.estat_proposta === 'Presentada amb requeriments') {
      this.incidenciesActuals = this.possiblePropIncidencies;
    } else if (this.data.estat_proposta === 'Aprovada en contractació') {
      this.incidenciesActuals = this.possiblePropEnIncidencies;
    } else if (this.data.estat_proposta === 'Contractada') {
      this.incidenciesActuals = this.possiblePropConIncidencies;
    } else {
      this.incidenciesActuals = [];
    }
  }

  public avaluar(codi): void {
   let dialogFactRef=this.dialog.open(DialogAvaluar, {disableClose: true, data: codi})
   
   dialogFactRef.afterClosed().subscribe(results => {
      if(!results)return;
      this.UpdateAvalua(results);
   });
  }

  public UpdateAvalua(data): void {
    this.showAsyncProgress = true;
      this.dataService.updateAvaluacio(data)
        .subscribe(updatedAvalua => {console.log("S'han desat les dades");this.showAsyncProgress = false;});
  }
  
  public formatUserNumber(camp) {
    //La pipe funciona, però el numero es converteix en text => Peta interficie, fallen operacions * canvi_moneda, s'ha de reconvertir abans de desar. S'hauria de fer per cada camp
    //this.data[camp] = this.formatPipe.transform(this.data[camp]);
  }

  public percentPropi(event?){
    this.percentatge_propi = (this.data.pressupost_ofertat && this.data.import_propi)?this.data.import_propi / this.data.pressupost_ofertat * 100:null;
  }

  public editInnovacio(codi): void {
   let dialogFactRef=this.dialog.open(DialogInnovacio, {disableClose: true, data: codi})
   
   dialogFactRef.afterClosed().subscribe(results => {
     if(!results)return;
     this.editInnovacioData = results.inno;
     this.editSoftData = results.soft;
     this.showDialog = false;
   });
  }

  public editFitxa(codi): void {
   let dialogFactRef=this.dialog.open(DialogFitxes, {disableClose: true, width: '700px', height: '600px', data: codi})
   
   dialogFactRef.afterClosed().subscribe(results => { this.showDialog = false; });
  }

  public esborrar(tipus){
    let segur = confirm("Confirmar l'esborrat");
    if(!segur)return;
    this.dataService.esborrar(tipus, this.data.codi).subscribe(results => { this.showDialog = false; });
  }

  public canviarCodi(){
    let nou_codi = prompt("Nou codi");
    if(!nou_codi)return;
    this.dataService.canviarCodi(this.data.codi, nou_codi);
  }

  public desarFitxer(event, fitxer, path){
    event.preventDefault();//!important evitar que la pàgina navegui al registre
    this.dataService.downloadFile(path, fitxer);
  }

  public eliminarFitxerImatge(event, i, fitxer){
    event.preventDefault();//!important evitar que la pàgina navegui al registre
    this.imgname.splice(i, 1);
    this.data.imatges = this.data.imatges
      .split(";")
      .filter(f => f !== fitxer)
      .join(";");
  }

  public percentSubcon(){if(!this.data)return;
    if(!this.data.pressupost_contractat_loc || !this.data.canvi_moneda)return;
    this.percentatge_subcon = ((this.data.pressupost_subcon*this.data.canvi_moneda_subcon)/this.data.pressupost_contractat_loc*this.data.canvi_moneda);
  }

  public getPossibleNewCodes(code: string): void {}
  public computeProjectLength(inputData: any): void {}

  public onSubmit(): void {
    if(!this.data.clau || this.data.clau.length < 5){alert("No es pot crear/desar.\r\nEl Nom ha de tenir un mínim de 5 caràcters.");return;}
    if(!this.data.codi || this.data.codi.length < 5)this.data.codi=this.data.clau;
    if(this.data.codi.length > 45 && this.isNew){alert("No es pot crear.\r\nEl codi té més de 45 caràcters.");return;}
    //if(!this.data.codi || this.data.codi.length < 5 && this.isNew){alert("No es pot crear.\r\nEl codi ha de tenir un mínim de 5 caràcters.");return;}
    if(this.data.clau.length > 30){alert("No es pot crear.\r\nEl nom té més de 30 caràcters.");return;}
 
    //if(this.data.nota == null)this.data.nota = '';
    //Vàlid per a propostes
    if(this.urlParam == "/proposals"){

      if(!this.tematica2 || this.tematica2.length == 0){alert("No es pot desar.\r\nS'ha de posar una temàtica 'Serveis'.");return;}
      if(!this.tematica3 || this.tematica3.length == 0){alert("No es pot desar.\r\nS'ha de posar una temàtica 'Sectors'.");return;}
      /*if(!this.tematica1 || this.tematica1.length == 0){alert("No es pot desar.\r\nS'ha de posar una temàtica 'Tipus específic'.");return;}
      if(!this.tematica5 || this.tematica5.length == 0){alert("No es pot desar.\r\nS'ha de posar una temàtica 'Sistemes'.");return;}*/
      if(this.data.empresa == "" || !this.data.empresa){alert("S'ha de seleccionar una empresa.");return}
      if(this.tipus_proposta_inicial != this.data.tipus_proposta && this.tipus_proposta_inicial)
             if(!confirm("ALERTA! S'ha canviat l'estat de la proposta. Si us plau, confirma aquest canvi?"))return;
      if(this.data.durada_mesos == "")alert("El camp durada de la proposta està en blanc. Es pot desar, però s'ha omplir.");
      if(this.data.cpv == "")alert("El CPV de la proposta està en blanc. Es pot desar, però s'ha omplir.");

      if(!this.data.data_limit_presentacio && this.data.data_presentacio_prop)this.data.data_limit_presentacio = this.data.data_presentacio_prop;
      if(this.data.data_limit_presentacio && !moment(this.data.data_limit_presentacio, 'YYYY-MM-DD',true).isValid()) {alert("Data límit presentació. Format ERROR.");return;}
      if(this.data.data_limit_presentacio == "")alert("La data límit de presentació de la proposta està en blanc. Es pot desar, però s'ha omplir.");

      if(this.data.data_inici_possible && !moment(this.data.data_inici_possible, 'YYYY-MM-DD',true).isValid()) {alert("Data inici possible. Format ERROR.");return;}
      if(this.data.data_inici_possible == "")alert("La data d'inici possible de la proposta està en blanc. Es pot desar, però s'ha omplir.");

      if(this.data.pressupost_licitacio == "")alert("El pressupost de licitació de la proposta està en blanc. Es pot desar, però s'ha omplir.");
      if(this.data.pressupost_ofertat == "")alert("El pressupost ofertat de la proposta està en blanc. Es pot desar, però s'ha omplir.");
      if(this.data.import_propi == "")alert("L'import propi de la proposta està en blanc. Es pot desar, però s'ha omplir.");
      if(this.data.estat_proposta == "En contractació" && (!this.data.tipus_incidencia || this.data.tipus_incidencia == "")){alert("A les propostes 'En contractació' se'ls ha d'omplir el camp d'incidències. No es pot desar.");return;}
      if(this.data.data_documentacio && !moment(this.data.data_documentacio, 'YYYY-MM-DD',true).isValid()) {alert("Data límit del requeriment. Format ERROR.");return;}
    }
 
    if(this.urlParam == "/proposalpe"){//garanteix que som a propostes i no treballs

      if(!this.tematica2 || this.tematica2.length == 0){alert("No es pot desar.\r\nS'ha de posar una temàtica 'Serveis'.");return;}
      if(!this.tematica3 || this.tematica3.length == 0){alert("No es pot desar.\r\nS'ha de posar una temàtica 'Sectors'.");return;}
      /*if(!this.tematica1 || this.tematica1.length == 0){alert("No es pot desar.\r\nS'ha de posar una temàtica 'Tipus específic'.");return;}
      if(!this.tematica5 || this.tematica5.length == 0){alert("No es pot desar.\r\nS'ha de posar una temàtica 'Sistemes'.");return;}*/
      if(this.data.empresa == "" || !this.data.empresa){alert("S'ha de seleccionar una empresa.");return}
      if(this.tipus_proposta_inicial != this.data.tipus_proposta && this.tipus_proposta_inicial)
             if(!confirm("ALERTA! S'ha canviat l'estat de la proposta. Si us plau, confirma aquest canvi?"))return;
      if(this.data.durada_mesos == "")alert("El camp durada de la proposta està en blanc. Es pot desar, però s'ha omplir.");
      if(this.data.cpv == "")alert("El CPV de la proposta està en blanc. Es pot desar, però s'ha omplir.");

      if(!this.data.data_limit_presentacio && this.data.data_presentacio_prop)this.data.data_limit_presentacio = this.data.data_presentacio_prop;
      if(this.data.data_limit_presentacio && !moment(this.data.data_limit_presentacio, 'YYYY-MM-DD',true).isValid()) {alert("Data límit presentació. Format ERROR.");return;}
      if(this.data.data_limit_presentacio == "")alert("La data límit de presentació de la proposta està en blanc. Es pot desar, però s'ha omplir.");

      if(this.data.data_inici_possible && !moment(this.data.data_inici_possible, 'YYYY-MM-DD',true).isValid()) {alert("Data inici possible. Format ERROR.");return;}
      if(this.data.data_inici_possible == "")alert("La data d'inici possible de la proposta està en blanc. Es pot desar, però s'ha omplir.");

      //if(this.data.pressupost_licitacio == "")alert("El pressupost de licitació de la proposta està en blanc. Es pot desar, però s'ha omplir.");
      //if(this.data.pressupost_ofertat == "")alert("El pressupost ofertat de la proposta està en blanc. Es pot desar, però s'ha omplir.");
      //if(this.data.import_propi == "")alert("L'import propi de la proposta està en blanc. Es pot desar, però s'ha omplir.");
      if(this.data.estat_proposta == "En contractació" && (!this.data.tipus_incidencia || this.data.tipus_incidencia == "")){alert("A les propostes 'En contractació' se'ls ha d'omplir el camp d'incidències. No es pot desar.");return;}
      if(this.data.data_documentacio && !moment(this.data.data_documentacio, 'YYYY-MM-DD',true).isValid()) {alert("Data límit del requeriment. Format ERROR.");return;}
    }

    //Vàlid per a projectes
    if(!(this.urlParam == "/proposals" || this.urlParam == "/proposalpe") && !this.data.data_finalitzacio){alert("No es pot desar.\r\nCal una data de finalització.");return;}
    if(this.data.percentatge_subcon > 1){alert("No es pot desar.\r\nLa subcontractació supera el 100% del pressupost contractat.");return;}
    if(this.data.pressupost_contractat_loc == "")alert("El pressupost contractat està en blanc. Es pot desar, però s'ha omplir.");
    if(this.data.pressupost_projecte_loc && this.data.pressupost_projecte_loc == "")alert("El pressupost del projecte de la proposta està en blanc. Es pot desar, però s'ha omplir.");
    if(this.data.preu_hora == "")alert("El preu hora està en blanc. Es pot desar, però s'ha omplir.");
    if(this.data.certificat == "Rebut" && this.data.certifname == ""){
      alert("El certificat no pot estar 'Rebut' i no haver-hi el nom del fitxer associat.");return;}
    if(this.data.pressupost_contractat_loc){//Control d'error a l'entrada de dades:
      this.data.pressupost_contractat = this.data.pressupost_contractat_loc*this.data.canvi_moneda;
      if((this.data.pressupost_loc*this.data.canvi_moneda_loc) > this.data.pressupost_contractat_loc*this.data.canvi_moneda){alert("No es pot desar.\r\nEl pressupost subcontractat es major o igual al propi.");return;}
    }
    else this.data.pressupost_contractat = 0;

    if(this.data.data_aprovacio && !moment(this.data.data_aprovacio, 'YYYY-MM-DD',true).isValid()) {alert("Data d'aprovació. Format ERROR.");return;}
    if(this.data.data_signatura && !moment(this.data.data_signatura, 'YYYY-MM-DD',true).isValid()) {alert("Data formalització/contractació. Format ERROR.");return;}
    if(this.data.data_pagament_garantia && !moment(this.data.data_pagament_garantia, 'YYYY-MM-DD',true).isValid()) {alert("Data de pagament. Format ERROR.");return;}
    if(this.data.data_finalitzacio && !moment(this.data.data_finalitzacio, 'YYYY-MM-DD',true).isValid()) {alert("Data de finalització. Format ERROR.");return;}
    if(this.data.data_dev_garantia && !moment(this.data.data_dev_garantia, 'YYYY-MM-DD',true).isValid()) {alert("Data de devolució de garantia. Format ERROR.");return;}
    if(this.data.data_presentacio_prop && !moment(this.data.data_presentacio_prop, 'YYYY-MM-DD',true).isValid()) {alert("Data de presentació de la proposta. Format ERROR.");return;}
    if(this.data.data_negociacio_prop && !moment(this.data.data_negociacio_prop, 'YYYY-MM-DD',true).isValid()) {alert("Data de negocició de la proposta. Format ERROR.");return;}
    if(this.data.data_aprovacio_prop && !moment(this.data.data_aprovacio_prop, 'YYYY-MM-DD',true).isValid()) {alert("Data d'aprovació de la proposta'. Format ERROR.");return;}

    if (!this.data)return;
    this.data.cpv = (this.cpv?this.cpv.join(";"):null);
    this.data.tematica1 = (this.tematica1[0]?this.tematica1.join(";"):null);
    this.data.tematica2 = (this.tematica2[0]?this.tematica2.join(";"):null);
    this.data.tematica3 = (this.tematica3[0]?this.tematica3.join(";"):null);
    this.data.tematica4 = (this.tematica4[0]?this.tematica4.join(";"):null);
    this.data.tematica5 = (this.tematica5[0]?this.tematica5.join(";"):null);
    if(this.data.canvi_moneda_press_proj*this.data.pressupost_projecte_loc)this.data.pressupost_projecte = this.data.canvi_moneda_press_proj*this.data.pressupost_projecte_loc;
    else this.data.pressupost_projecte = 0;

    const action: 'UPDATE' | 'CREATE' = (this.isNew ? 'CREATE' : 'UPDATE');
    if(this.data["certifname"]){
       if(this.data["certifname"] != "")this.data.certificat="Rebut";
       else if(this.data.certificat == "Rebut")this.data.certificat="Pendent";
    }

    // No es pot crear una proposta des de manifestacions d'inteès. Només Updatejar
    if(action == 'CREATE' && this.data.tipus_proposta == 1 && this.urlParam == "/proposalpe"){
        this.data.tipus_proposta = 2;
    }
    this.requestChange.emit({
      action: action,
      payload: {data: this.data, inno: this.editInnovacioData, soft: this.editSoftData}
    });
  }

  @ViewChild('quillEditor', { static: false }) editor;
 
  constructor(public translate: TranslateService, public languageService: LanguageService, protected dataService: ProjectsService | ProposalsService, private tokenStorage: TokenStorageService, protected route: ActivatedRoute, protected router: Router, private urlParam: string, private cdr: ChangeDetectorRef, private formatPipe: NumberFormatPipe
    , private dialog: MatDialog, private notesService: NotesService) { this.rol = this.tokenStorage.getRol();this.userInfo = this.tokenStorage.getUser(); }

  public goBack(){
     if(this.router.url.indexOf("/proposalpe/") != -1)this.router.navigate(['/proposalpe',{}]);
     else this.router.navigate([this.urlParam,{}]);
   };

  afegir(event){
    //data
    if(!event && (!this.data.nota || this.data.nota.indexOf("[" + this.dia + "]") == -1))
      this.data.nota = "[" + this.dia + "] ("+this.userInfo.name+"): <p>&nbsp;</p>" + (this.data.nota?this.data.nota:'') + "<p>&nbsp;</p>";
    //seguiment
    if(event){
      this.editor.quillEditor.format('color', 'dark-green'); 
      this.editor.quillEditor.insertText(this.quillPos, "★ "+event.source.triggerValue+" ★", {'color': '#009900','bold': true});
    }
  }

  afegirE(){
    if(!this.data.nota_e || this.data.nota_e.indexOf("[" + this.dia + "]") == -1)
      this.data.nota_e = "[" + this.dia + "] ("+this.userInfo.name+"): \r\n" + (this.data.nota_e?this.data.nota_e:'') + "\r\n";
  }

  setPos(event){
    if(event.range)this.quillPos = event.range.index;
    else if(event.oldRange)this.quillPos = event.oldRange.index;
  }

  chgDataPresentacio(event){
    this.data.data_presentacio_prop = event;
    this.data.data_limit_presentacio = event;
  }

  ngOnInit() {
    this.getPossibleNewCodes('');
    if(!this.dia)this.dia = moment().format("YYYY-MM-DD");
    this.diaFull = moment().format("DD-MMMM-YYYY");
    this.proposta = this.router.url.indexOf("/proposalpe/") == -1;//Detecta propostes / manifestacions d'interès per avisar del canvi de taula

    //this.dataService.getStates(this.proposta).subscribe(states => this.possibleStates = states, err => console.log(err));
    this.dataService.getStates(this.proposta).subscribe(estats => {
      this.possibleStates = estats.map(nomCatala => ({
        codi: nomCatala, // ← s'envia/compara SEMPRE en català
        text: this.languageService.label('estatRaw', nomCatala) // ← només es mostra traduït
      }));
    });

    //this.dataService.getAmbits().subscribe(ambits => this.possibleAmbits = ambits, err => console.log(err));
    this.dataService.getAmbits().subscribe(ambits => {
      this.possibleAmbits = ambits.map(nomCatala => ({
        codi: nomCatala["value"], // ← s'envia/compara SEMPRE en català
        text: this.languageService.label('ambitsRaw', nomCatala["text"]) // ← només es mostra traduït
      }));
    });

    //this.dataService.getMonedes().subscribe(monedes => this.possibleMonedes = monedes, err => console.log(err));
    this.dataService.getMonedes().subscribe(monedes => {
      this.possibleMonedes = monedes.map(nomCatala => ({
        codi: nomCatala["value"], // ← s'envia/compara SEMPRE en català
        text: this.languageService.label('monedesRaw', nomCatala["value"]) // ← només es mostra traduït
      }));
    });

    //this.dataService.getTipus().subscribe(tipus => this.possibleTipus = tipus, err => {return;});
    this.dataService.getTipus().subscribe(tipus => {
      this.possibleTipus = tipus.map(nomCatala => ({
        codi: nomCatala['value'], // ← s'envia/compara SEMPRE en català
        text: this.languageService.label('projecteTipusPropostaRaw', nomCatala['text']) // ← només es mostra traduït
      }));
    });

    //this.dataService.getAutocomplete("tipGarantia").subscribe(tipus => this.possibleTipGarantia = tipus, err => {return;});
    this.dataService.getAutocomplete("tipGarantia").subscribe(tipus => {
      this.possibleTipGarantia = tipus.map(nomCatala => ({
        codi: nomCatala.text, // ← s'envia/compara SEMPRE en català
        text: this.languageService.label('garantiaRaw', nomCatala.text) // ← només es mostra traduït
      }));
    });

    //Desactivar quan canviï l'APP
    //this.dataService.getAutocomplete("tipPropIncidencia").subscribe(tipus => this.possibleIncidencia = tipus, err => {return;});
    if(this.proposta){
      //this.dataService.getAutocomplete("tipPropIncidencies").subscribe(tipus => { this.possiblePropIncidencies = tipus}, err => {return;});
      this.dataService.getAutocomplete("tipPropIncidencies").subscribe(tipus => {
        this.possiblePropIncidencies = tipus.map(nomCatala => ({
          codi: nomCatala.text, // ← s'envia/compara SEMPRE en català
          text: this.languageService.label('tipPropIncidenciesRaw', nomCatala.text) // ← només es mostra traduït
        }));
      });


      //this.dataService.getAutocomplete("tipPropEnIncidencies").subscribe(tipus => { this.possiblePropEnIncidencies = tipus}, err => {return;});
      this.dataService.getAutocomplete("tipPropEnIncidencies").subscribe(tipus => {
        this.possiblePropEnIncidencies = tipus.map(nomCatala => ({
          codi: nomCatala.text, // ← s'envia/compara SEMPRE en català
          text: this.languageService.label('tipPropIncidenciesRaw', nomCatala.text) // ← només es mostra traduït
        }));
      });

      //this.dataService.getAutocomplete("tipPropConIncidencies").subscribe(tipus => {this.possiblePropConIncidencies = tipus}, err => {return;});
      this.dataService.getAutocomplete("tipPropConIncidencies").subscribe(tipus => {
        this.possiblePropConIncidencies = tipus.map(nomCatala => ({
          codi: nomCatala.text, // ← s'envia/compara SEMPRE en català
          text: this.languageService.label('tipPropIncidenciesRaw', nomCatala.text) // ← només es mostra traduït
        }));
      });
    }
    else
      //this.dataService.getAutocomplete("tipPrePropIncidencies").subscribe(tipus => {this.possiblePrePropIncidencies = tipus}, err => {return;});
      this.dataService.getAutocomplete("tipPrePropIncidencies").subscribe(tipus => {
        this.possiblePrePropIncidencies = tipus.map(nomCatala => ({
          codi: nomCatala.text, // ← s'envia/compara SEMPRE en català
          text: this.languageService.label('tipPropIncidenciesRaw', nomCatala.text) // ← només es mostra traduït
        }));
      });

    //this.dataService.getConsorcis().subscribe(consorci => this.possibleConsorcis = consorci, err => {return;});
    //this.dataService.getConsorcis().subscribe(consorci => {
    //  this.possibleConsorcis = consorci.map(nomCatala => ({
    //    codi: nomCatala, // ← s'envia/compara SEMPRE en català
    //    text: this.languageService.label('consorcisRaw', nomCatala) // ← només es mostra traduït
    //  }));
    //});
    
    //Per defecte ja ve amb multiples idiomes
    this.dataService.getAutocomplete("cpv").subscribe(tipus => {
       this.possibleCPV = tipus;
       this.cpv = (this.data && this.data["cpv"]?this.data["cpv"].split(";"):null);
     }, err => {return;}
    );

    //this.dataService.getAutocomplete("motiu_prop").subscribe(motius => this.possibleMotius = motius, err => {return;});
    this.dataService.getAutocomplete("motiu_prop").subscribe(motius => {
      this.possibleMotius = motius.map(nomCatala => ({
        codi: nomCatala.text, // ← s'envia/compara SEMPRE en català
        text: this.languageService.label('motiusRaw', nomCatala.text) // ← només es mostra traduït
      }));
    });

    this.dataService.getTematiques(1)
    .subscribe(
      temes => {
        //this.possibleTematiques1 = temes;
        this.possibleTematiques1 = temes.map(nomCatala => ({
          codi: nomCatala["tematica1"], // ← s'envia/compara SEMPRE en català
          text: this.languageService.label('tematicaRaw', nomCatala["tematica1"]) // ← només es mostra traduït
        }));
        this.tematica1 = (this.data && this.data.tematica1?this.data.tematica1.split(";"):'');
        this.dataService.getTematiques(2)
        .subscribe(
          temes => {
          //this.possibleTematiques2 = temes;
          this.possibleTematiques2 = temes.map(nomCatala => ({
            codi: nomCatala["tematica2"], // ← s'envia/compara SEMPRE en català
            text: this.languageService.label('tematicaRaw', nomCatala["tematica2"]) // ← només es mostra traduït
          }));
          this.tematica2 = (this.data && this.data.tematica2?this.data.tematica2.split(";"):'');
          this.dataService.getTematiques(3)
          .subscribe(
            temes => {
            //this.possibleTematiques3 = temes;
            this.possibleTematiques3 = temes.map(nomCatala => ({
              codi: nomCatala["tematica3"], // ← s'envia/compara SEMPRE en català
              text: this.languageService.label('tematicaRaw', nomCatala["tematica3"]) // ← només es mostra traduït
            }));
            this.tematica3 = (this.data && this.data.tematica3?this.data.tematica3.split(";"):'');
            this.dataService.getTematiques(4)
            .subscribe(
              temes => {
              //this.possibleTematiques4 = temes;
              this.possibleTematiques4 = temes.map(nomCatala => ({
                codi: nomCatala["tematica4"], // ← s'envia/compara SEMPRE en català
                text: this.languageService.label('tematicaRaw', nomCatala["tematica4"]) // ← només es mostra traduït
              }));
              this.tematica4 = (this.data && this.data.tematica4?this.data.tematica4.split(";"):'');
              this.dataService.getTematiques(5)
              .subscribe(
                temes => {
                //this.possibleTematiques5 = temes;
                this.possibleTematiques5 = temes.map(nomCatala => ({
                  codi: nomCatala["tematica5"], // ← s'envia/compara SEMPRE en català
                  text: this.languageService.label('tematicaRaw', nomCatala["tematica5"]) // ← només es mostra traduït
                }));
                this.tematica5 = (this.data && this.data.tematica5?this.data.tematica5.split(";"):'');
                
                //this.dataService.getUtes().subscribe(utes => this.possibleUtes = utes, err => {return;});
                this.dataService.getUtes().subscribe(motius => {
                  this.possibleUtes = motius.map(nomCatala => ({
                    codi: nomCatala["codi"], // ← s'envia/compara SEMPRE en català
                    text: this.languageService.label('motiusRaw', nomCatala["text"]) // ← només es mostra traduït
                  }));
                });

                //this.notesService.getAutocomplete('seguiments', this.data.codi?this.data.codi:'').subscribe(consorci => this.seguimentsTreballs = consorci, err => {return;});
                this.notesService.getAutocomplete("seguiments", this.data.codi?this.data.codi:'').subscribe(motius => {
                  this.seguimentsTreballs = motius.map(nomCatala => ({
                    codi: nomCatala.text, // ← s'envia/compara SEMPRE en català
                    text: this.languageService.label('tipSeguimentTecnicRaw', nomCatala.text) // ← només es mostra traduït
                  }));
                });

                //Vàlid per a propostes
                this.percentPropi();
                this.data.tipus_proposta = (this.data.tipus_proposta == 0 || !this.data.tipus_proposta?(this.proposta?1:2):this.data.tipus_proposta);
                this.tipus_proposta_inicial = this.data.tipus_proposta?this.data.tipus_proposta:null;
                this.data.estat_pla = (this.data.estat_pla?this.data.estat_pla:'No aplica');
                this.data.pressupost_projecte_loc = (this.data.pressupost_projecte_loc?this.data.pressupost_projecte_loc:this.data.pressupost_ofertat);
                //Fi vàlid per a propostes
                this.dataService.getFitxaComanda(this.data.codi?this.data.codi:'').subscribe(fitxa => { this.fitxaComanda = fitxa;});
                this.imgname = (this.data.imatges?this.data.imatges.split(";"):[]);


                this.onEstatChange();
              });
            });
          });
        });
    });

    history.pushState(null,  document.title, location.href);

    fromEvent(window, 'popstate').pipe(
      takeUntil(this.unsubscriber)
    ).subscribe((_) => {
      history.pushState(null, '');
    });
  }

  exportFitxa(): void {
        var preHtml = "<html xmlns:o='urn:schemas-microsoft-com:office:office' xmlns:w='urn:schemas-microsoft-com:office:word' xmlns='http://www.w3.org/TR/REC-html40'><head><meta charset='utf-8'><title>Dades del Centre</title>";
        var postHtml = "</body></html>";
        preHtml = preHtml + "<style>"+".dialogContainer {  padding: 10px;}.mat-select {padding-top: 0px;}.mat-card {padding: 0px;}";
        preHtml = preHtml + ".lbl_dlg{float:left;clear:none;font-style: italic;color: #009d44!important;padding-top: 7px;padding-left: 20px;}";
        preHtml = preHtml + ".lbl_sh{ padding-top: 0px;}.txt_dlg{float:left;clear:none;padding-left: 5px;}";
        preHtml = preHtml + ".mat-dialog-container{overflow-x: hidden;overflow-y: auto}";
        preHtml = preHtml + "::ng-deep";
        preHtml = preHtml + ".mat-radio-button {padding-left:20px}";
        preHtml = preHtml + ".mat-dialog-content {display: inline;max-height: 100%}";
        preHtml = preHtml + "::ng-deep :root .mat-tab-body-content {;overflow: hidden}</style></head><body style='font-size:0.7em;font-family:Arial'>";
    
        var html = preHtml+document.getElementById('exportComanda').innerHTML+postHtml;

        var blob = new Blob(['\ufeff', html], { type: 'application/msword' });
        // Specify file name
        let filename = this.data.codi+'-FULL-COMANDA.doc';

        // Specify link url
        var url = 'data:application/vnd.ms-word;charset=utf-8,' + encodeURIComponent(html);
    
        // Create download link element
        var downloadLink = document.createElement("a");

        document.body.appendChild(downloadLink);
    
        const nav = (window.navigator as any);
    if (nav.msSaveOrOpenBlob) { nav.msSaveOrOpenBlob(blob, filename); }

    if((window.navigator as any).msSaveOrOpenBlob ){ (window.navigator as any).msSaveOrOpenBlob(blob, filename); }
    else{
        // Create a link to the file
        downloadLink.href = url;
        
        // Setting the file name
        downloadLink.download = filename;
        
        //triggering the function
        downloadLink.click();
    }
    
    document.body.removeChild(downloadLink);

  }

  ngOnDestroy(): void {
    this.unsubscriber.next();
    this.unsubscriber.complete();
  }
  
  public esDesable(){
    if(!this.data.certificat || this.data.certificat == '')this.data.certificat = 'Pendent';
    if(!this.data.fitxa_descriptiva || this.data.fitxa_descriptiva == '')this.data.fitxa_descriptiva = 'Pendent';
    
    this.espotDesar = (this.data.estat_projecte !== 'Finalitzat pendent de cobrament') || (this.data.estat_projecte === 'Finalitzat pendent de cobrament' && this.data.certificat != '')
    this.cdr.detectChanges();
  }
 
  public onFileChange(event, camp) {
    let reader = new FileReader();

    if(event.target.files && event.target.files.length > 0) {
      let file = event.target.files[0];
      reader.readAsDataURL(file);
      reader.onload = () => {
        if(file.size > 100000000){
          alert("Limit del fitxer a pujar 100Mb!");
          this.data[camp+"name"] = '';
          return;
        };
        this.data[camp+"name"] = file.name;
        this.data[camp] = {
          filename: file.name,
          filetype: file.type,
          value: reader.result
        };
      };
    }else {this.data[camp] = null;this.data[camp+"name"] = '';}
  }

  public onFileImgChange(event, camp) {
    const files: FileList = event.target.files;
    if (!files || files.length === 0) {
      this.data[camp+"name"] = [];
      return;
    }
    if (files.length > 5) {
      alert("Només pots pujar fins a 5 imatges.");
      return;
    }

    this.data[camp] = [];   // array d’imatges

    Array.from(files).forEach((file: File) => {
      if (file.size > 300000) {
        alert(`La imatge ${file.name} supera el límit de 300Kb`);
        return;
      }
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        this.data[camp].push({
          filename: file.name,
          filetype: file.type,
          value: reader.result
        });
      };
    });
  }

  onThumbError(event: Event) {
    const imgEl = event.target as HTMLImageElement;
    imgEl.src = '';
    imgEl.onerror = null; // evitar bucle si el placeholder falla
  }

  ngOnChanges(changes: {[propertyName: string]: SimpleChange}) {
    if (changes['data'] && changes['data'].currentValue) {
      this.esDesable();
      this.computeProjectLength(changes['data'].currentValue);
      this.percentSubcon();
    }
  }
}

@Component({
  templateUrl: 'proposal-data.component.html',
  selector: 'mcrit-gestio-manage-proposal-data',
  styleUrls: ['base-data.component.css'],
  providers: [NotesService, FormatNumberPipe, NumberFormatPipe],
  inputs : ['data', 'showAsyncProgress', 'isNew'],
  outputs : ['requestChange']
})

export class ProposalDataComponent extends BaseDataComponent {
  //public possibleStates: Array<string>;
  public possibleStates: { codi: string; text: string; }[];

  public ambitProposta: Array<string>;

  public goProject(){this.router.navigate(['project',this.data.codi]);};

  constructor(public translate: TranslateService, public languageService: LanguageService, proposalsService: ProposalsService, tokenStorage: TokenStorageService, router: Router, route: ActivatedRoute, cdr: ChangeDetectorRef, formatPipe: NumberFormatPipe, dialog: MatDialog, notesService: NotesService) {
    super(translate, languageService, proposalsService, tokenStorage, route, router, '/proposals', cdr, formatPipe, dialog, notesService);
  }
}
//VEURE: https://www.positronx.io/understand-angular-change-detection-strategy/
@Component({
  templateUrl: 'project-data.component.html',
  selector: 'mcrit-gestio-manage-project-data',
  styleUrls: ['base-data.component.css'],
  providers: [NotesService, FormatNumberPipe, NumberFormatPipe],
  inputs : ['data', 'showAsyncProgress', 'isNew'],
  outputs : ['requestChange']
})

export class ProjectDataComponent extends BaseDataComponent {
  public showPossibleCodes = false;
  public posssibleCodesList: Array<{codi: string, titol: string}>;
  public duradaProjecte: number = 0;

  public setNewCode(codi: string): void {
    this.data['codi'] = codi;
  }

  public computeProjectLength(inputData: any): void {
    const [startDate, endDate] = ['data_signatura', 'data_finalitzacio']
      .map(key => new Date(inputData[key]))
      .map(date => date.getTime());
    if (Number.isNaN(startDate) || Number.isNaN(endDate))return;
    this.duradaProjecte = parseFloat(Math.max(0, ((endDate - startDate) / 86400000 / 30)).toFixed(1));
  }

  public getPossibleNewCodes(code: string): void {
     this.dataService.getPossibleNewCodes(code)
      .subscribe(
        list => {
          this.posssibleCodesList = list;
        },
        err => console.log(err)
      );
  }

  public requestSeguimentTecnic($event): void {
    $event.preventDefault();
    this.router.navigate(['project', this.data.codi, 'seguimentTecnic']);
  }

  public requestInvoicesReb($event): void {
    $event.preventDefault();
    this.router.navigate(['project', this.data.codi, 'invoicesReb']);
  }

  public requestInvoices($event): void {
    $event.preventDefault();
    this.router.navigate(['project', this.data.codi, 'invoices']);
  }

  public goProposal(){ this.router.navigate(['proposal',this.data.codi]);};

  public setDestacat($event){if(!this.data.destacat)this.data.destacat=true;else this.data.destacat=!this.data.destacat;}
  public setInnovador($event){if(!this.data.innovador)this.data.innovador=true;else this.data.innovador=!this.data.innovador;}

  constructor(public translate: TranslateService, public languageService: LanguageService, projectsService: ProjectsService, router: Router, tokenStorage: TokenStorageService, route: ActivatedRoute, cdr: ChangeDetectorRef, formatPipe: NumberFormatPipe
    , dialog: MatDialog, notesService: NotesService) {
    super(translate, languageService, projectsService, tokenStorage, route, router, '/projects', cdr, formatPipe, dialog, notesService);
  }

}
